var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 48a48 48 0 1 1-96 0 48 48 0 0 1 96 0ZM61.5 25.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Zm-5 20.5c.2 1 0 2-.2 3l-4.6 19.5c.9 2 2.1 3.4 8.4 1.5 3 5.3-8.7 7-13 7-3.3 0-8-3.7-8-7v-1l-.1-.5a2.3 2.3 0 0 1 .2-.7l4.7-20.1c-.8-2-2-3.7-8.4-1.7-3-5.3 8.7-7 13-7 3.3 0 8 3.7 8 7Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.5f93452d8d484954b6f7da39840957d4.svg";
export { ForwardRef as ReactComponent };